// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-centered">
      <hr className="footer-divider" />
      <div className="footer-text">© 2025 BlockCode. All rights reserved.</div>
      <div className="footer-links">
        <Link to="/coming-soon">Coming Soon</Link>
        <span>|</span>
        <Link to="/contactus">Contact Us</Link>
        {/* <span>|</span>
        <Link to="/review">Leave a Review</Link> */}
        <span>|</span>
        <Link to="/about-us">About Us</Link>
        <span>|</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span>|</span>
        <Link to="/legal">Legal</Link>
      </div>
    </footer>
  );
};

export default Footer;
